export const DEFINITION_QUERY_STRING = 'def';
export const DESTINATION_QUERY_STRING = 'to';
export const ORIGIN_QUERY_STRING = 'from';
export const PARTNER_ID_QUERY_STRING = 'id';
export const PARTNER_QUERY_STRING = 'p';
export const PARTNER_TYPE_QUERY_STRING = 't';
export const DEPRECATED_POPUP_ORIGIN_QUERY_STRING = 'd';
export const LANG_QUERY_STRING = 'lang';
